import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize, throwError } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { environment } from 'src/environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loader = inject(LoaderService)

  const token = authService.obtenerTokenSesion();
  const isAmadeusApi = req.url.startsWith(environment.amadeusApi);

  const clonedReq = (token && !isAmadeusApi)
    ? req.clone({ setHeaders: { 'x-session-token': token } })
    : req;
  loader.loading = true;


  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authService.cerrarSesion();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    }),
    finalize(() => loader.loading = false)
  );
};
